import base from "../utils/stores/base";
import AUTH_CONSTANTS from "../constants/authConstants";

let authStore = {
    getInitialState() {
        return {
            token: this.app.data.addressToken
        };
    },
    handlers: {},
    isLoggedIn() {
        return !!this.getToken();
    },
    getToken() {
        return this.state.token;
    }
};

export default base(authStore, AUTH_CONSTANTS);



/** WEBPACK FOOTER **
 ** ./app/stores/authStore.js
 **/